define('shoptheme/components/ui/anchor-navigation',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints,
	enquire
) {

	var BLOCK_ANCHOR_NAVIGATION = "anchor-navigation";
	var BLOCK_HEADLINES = "heading-container";

	var SELECTOR_CONTAINER = ".b_main-container__col2-right-col-main";

	var instances = [];
	var isMobile = true;

	enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
		match: function() {
			isMobile = false;

			_.forEach(instances, function(instance) {
				instance.place();
			});
		},
		unmatch: function() {
			isMobile = true;

			_.forEach(instances, function(instance) {
				instance.place();
			});
		}
	}, true);


	return Component.create({

		$init: function() {
			var self = this;

			this.container = $(SELECTOR_CONTAINER);
			this.headlines = this.container.find("h1, h2");

			this.mobileSpace = $('.b_main-container__col2-right-col-main');
			this.desktopSpace = $('.b_main-container__col2-right-col-right--sidebar');

			this.dom = this.buildDom();

			this.place();

			this.listBlock = BEM.block(BLOCK_ANCHOR_NAVIGATION);
			this.list = this.listBlock.getElements("list");
			this.links = this.listBlock.getElements("link");

			this.crawl();
			this.bindEvents();

			instances.push(this);
		},

		buildDom: function() {
			var domContainer 	= $('<div class="' + BEM.buildBlockClassname(BLOCK_ANCHOR_NAVIGATION) + '" />'),
				titleContainer 	= $('<div class="' + BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, 'title-container') + '" />'),
				listTitle 		= $('<strong class="' + BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, 'title') + '">' + Translator.translate("In this article:") + '</strong>'),
				listContainer 	= $('<ol class="' + BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, 'list') + '" />');

			return domContainer.append(titleContainer.append(listTitle)).append(listContainer);
		},

		place: function() {
			if (isMobile) {
				this.headlines.first().before(this.dom);
			} else {
				this.desktopSpace.prepend(this.dom);
			}
		},

		crawl: function() {
			var self = this;

			this.container.find(this.headlines).each(function(i) {
				self.addItem($(this), i);
			});
		},

		addItem: function(item, i) {
			var cleanRegExp = RegExp("^" + (i+1) + "\\.\\s*"),
				linkTitle = _.trim(item.text().replace(cleanRegExp, "")),
				listItem = $('<li class="' + BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, "list-item") + '" />'),
				//link = $('<a href="#" title="' + linkTitle + '" class="' +  BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, 'link') + '">' + linkTitle + '</a>');
				link = $('<a href="#" title="' + _.escape(linkTitle) + '" class="' +  BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, "link") + '">' + _.escape(linkTitle) + '</a>');

			link.data("content-item", item);

			this.list.append(listItem.append(link));
		},

		bindEvents: function() {
			var self = this;
			this.list.on("click", "." + BEM.buildElementClassname(BLOCK_ANCHOR_NAVIGATION, "link"), function(e) {
				e.preventDefault();
				self.onLinkClick(e.target);
			});
		},

		onLinkClick: function(link) {
			var item = $(link).data("content-item");
			var position = item.offset().top;

			$('html, body').animate({
				scrollTop: position - 15
			}, 500);
		}


	});

});
